import * as t from "io-ts";

import fetchApi from "ui-io/fetch-api";
import { BulkEventType } from "../../task-io";
import { TaskEventKeyT } from "ui-io/task-io/analytics";

export const TaskEventMutationSuccessIO = t.intersection([
  t.type({
    task_id: t.string,
  }),
  t.partial({
    current_state: t.string,
    assignee: t.union([t.string, t.null]),
  }),
]);

export const TaskEventMutationErrorIO = t.type({
  task_id: t.string,
  errors: t.array(t.string),
});

const TaskEventMutationResultIO = t.type({
  tasks: t.array(
    t.union([TaskEventMutationSuccessIO, TaskEventMutationErrorIO])
  ),
});

/** TODO: Not sure if this is correct, but works for now */
// const TaskEventMutationResultUnionIO = t.union([
//   TaskEventMutationResultIO,
//   TaskEventMutationSuccessIO,
// ]);

export const taskEventMutation = ({
  taskId,
  eventType: event_type,
  user,
  updatedBy
}: {
  taskId: string;
  eventType: TaskEventKeyT;
  user?: string;
  updatedBy?: string;
}) =>
  fetchApi({
    service: "admin-service",
    method: "POST",
    pathname: `/tasks/${taskId}/events`,
    body: { event_type, user, updatedBy },
    codec: TaskEventMutationSuccessIO,
  });

export const taskBulkEventsMutation = ({
  taskIds: task_ids,
  eventType: event_type,
  user,
  updatedBy,
}: {
  taskIds: string[];
  eventType: BulkEventType;
  user?: string;
  updatedBy?: string;
}) =>
  fetchApi({
    service: "admin-service",
    method: "POST",
    pathname: `/tasks/bulk_events`,
    body: {
      tasks: task_ids.map((task_id) => ({ task_id })),
      user,
      event_type,
      updatedBy,
    },
    codec: TaskEventMutationResultIO,
  });

export const taskTestRunMutation = ({
  taskId,
}: {
  taskId: string
}) =>
  fetchApi({
    service: 'admin-service',
    method: 'POST',
    pathname: `/test_runs/tasks/${taskId}`,
    codec: t.unknown,
  })

// export const taskUnblockFromRadarMutation = ({
//   radars,
// }: {
//   radars: string[]
// }) =>
//   fetchApi({
//     service: 'admin-service',
//     method: 'POST',
//     pathname: `/tasks/_unblock_from_radars`,
//     body: JSON.stringify({ radars }),
//     codec: t.unknown, // TODO
//   })
